import EmptyState from 'hb-builder/components/common/state/EmptyState';

const EmptyDynamicState = ({ component, type, ...styleProps }) => (
  <EmptyState {...styleProps} fontFamily="Inter" height="300px" width="100%">
    {s__(
      "Builder|You don't have published any %{type} to display in the %{component} at the moment",
    ).i__({ component, type })}
  </EmptyState>
);

export default EmptyDynamicState;
